@if (form) {
  <div class="box-signle mt-3">
    <div class="row">
      <div class="col-12">
        <p><span [innerHTML]="form.question_name"></span> @if (form.question_required) {
          <span class="required">*</span>
        }</p>
        @for (sm of form.choices; track trackByIndex($index)) {
          <div class="d-flex mt-2 choice-row" [class.choice-full]="isChoiceFull(sm)" (click)="selectChoice(sm)">
            <p-radiobutton name="pizza" [disabled]="form.view || isChoiceFull(sm)" [value]="sm.question_choice_id"
            [inputId]="sm.choice_name" [(ngModel)]="value" (onClick)="updateValue(val)" (click)="$event.stopPropagation()" #val></p-radiobutton>
            @if (sm.choice_media_url) {
              <img class="choice-media-img ml-2" [src]="resolveChoiceMediaUrl(sm.choice_media_url)" alt="" />
            }
            <span class="ml-2" [innerHTML]="sm.choice_name"></span>
            @if (isChoiceFull(sm)) {
              <span class="ml-2 choice-full-badge">เต็มแล้ว</span>
            }
          </div>
        }
        <!-- ช่องกรอกข้อความสำหรับตัวเลือก "อื่น ๆ (ระบุ)" — โชว์เมื่อเลือกตัวเลือกนั้น -->
        @if (selectedIsOther) {
          <div class="other-input mt-2">
            <input type="text" class="other-text-input w-100" [disabled]="form.view"
              placeholder="โปรดระบุ..." [(ngModel)]="otherText" (ngModelChange)="onOtherText()" />
          </div>
        }
        <!-- <app-validate-items [action]="form.question_required" [valid]="value"
        (validUpdate)="updateValiDate($event)">
        <div class="d-flex mt-2" *ngFor="let sm of form.choices">
          <p-radiobutton name="pizza" [disabled]="form.view" [value]="sm.question_choice_id"
            [inputId]="sm.choice_name" [(ngModel)]="value" (onClick)="updateValue(val)"
          #val></p-radiobutton>
          <span class="ml-2">{{sm.choice_name}}</span>
        </div>
      </app-validate-items> -->
    </div>
  </div>
</div>
}